import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import {
  HasPhotoContainer,
  HasVideoContainer,
  PublicationDateContainer as PublicationDateFilterContainer,
} from './containers';
import { WithLayoutContainer } from '../WithLayoutContainer';
import { useSelector } from 'react-redux';
import { selectIsMixedListing } from 'shared/selectors/jsonQuery';

export const PublicationDateContainer: FC = () => {
  const isMixed = useSelector(selectIsMixedListing);

  return (
    <AdvancedFilterRow label="Дата публикации">
      <InlineFilterGroup>
        <InlineFilter>
          <PublicationDateFilterContainer />
        </InlineFilter>
        <InlineFilter>
          <HasPhotoContainer />
        </InlineFilter>
        <InlineFilter>
          <HasVideoContainer />
        </InlineFilter>
        {isMixed && (
          <InlineFilter>
            <WithLayoutContainer />
          </InlineFilter>
        )}
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
